import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const sections = [
  { label: "👤 Account Info", path: "/dashboard/settings/account" },
  // Future:
  // { label: '💳 Payment Method', path: '/dashboard/settings/payment' },
  // { label: '🔒 Security', path: '/dashboard/settings/security' },
  // { label: '🔔 Notifications', path: '/dashboard/settings/notifications' },
  // { label: '⚙️ Preferences', path: '/dashboard/settings/prefs' },
];

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="mx-auto mt-8 max-w-xl rounded-2xl border border-white/10 bg-slate-900/90 px-5 py-6 text-slate-100 shadow-xl shadow-black/40 backdrop-blur">
      {/* Back */}
      <button
        type="button"
        onClick={() => navigate("/dashboard")}
        className="mb-4 inline-flex items-center gap-1 text-sm text-cyan-300 underline decoration-cyan-400/70 underline-offset-4 hover:text-cyan-200"
      >
        ← Back to Dashboard
      </button>

      {/* Title */}
      <h1 className="text-center text-xl font-semibold text-sky-200 md:text-2xl">
        Settings
      </h1>
      <p className="mt-2 text-center text-xs text-slate-400">
        Manage your account information and platform settings for Dreamframe
        Collab Hub.
      </p>

      {/* Sections */}
      <div className="mt-5 space-y-2">
        {sections.map((section) => {
          const isActive = location.pathname.startsWith(section.path);
          return (
            <Link
              key={section.path}
              to={section.path}
              className={`flex items-center justify-between rounded-xl border px-4 py-3 text-sm transition ${
                isActive
                  ? "border-fuchsia-400/70 bg-fuchsia-500/15 text-fuchsia-100"
                  : "border-white/5 bg-slate-800/70 text-slate-100 hover:border-sky-400/60 hover:bg-slate-800"
              }`}
            >
              <span>{section.label}</span>
              <span className="text-[11px] text-slate-400">
                {isActive ? "Viewing" : "Open"}
              </span>
            </Link>
          );
        })}
      </div>

      <p className="mt-4 text-[11px] text-slate-400">
      Features like payment options and advanced preferences open up based on your activity. The more you collaborate and build, the more you unlock.
      </p>
    </div>
  );
};

export default Settings;
